import { useList } from "@inmagik/react-crud"
import { API_URL } from "../../constants"
import { Scheda } from "../../types"

export function useSchedaList(params: Record<string, string> = {}) {
  return useList<Scheda>(`${API_URL}/schede-servizi`, { query: params })
}
